<template>
  <a v-if="visible" @click="onClick"><span></span></a>
</template>

<script>
  export default {
    name: "TableTransferButton",
    props: ['playerId','visible'],
    methods: {
      onClick() {
        this.$router.replace(`/club/invoice/${this.playerId}/transfer`);
      }
    }
  }
</script>

<style scoped>
  a {
    text-decoration: none;
    color: #369;
    width: 20px;
    height: 16px;
    margin-right: 1px;
    border-radius: 3px;
    border: 1px solid #aed0ea;
    background: #d7ebf9 url(../../../../assets/ui-bg_glass_80_d7ebf9_1x400.png) 50% 50% repeat-x;
    font-weight: bold;
    font-family: Lucida Grande,Lucida Sans,Arial,sans-serif;
    font-size: 1em;
    display: inline-block;
    position: relative;
    padding: 0;
    line-height: normal;
    cursor: pointer;
    vertical-align: middle;
    text-align: center;
    overflow: visible;
  }

  a:hover {
    border: 1px solid #74b2e2;
    background: #d7ebf9 url(../../../../assets/ui-bg_glass_100_e4f1fb_1x400.png) 50% 50% repeat-x;

  }

  span {
    left: 50%;
    margin-left: -8px;
    position: absolute;
    top: 50%;
    margin-top: -8px;
    width: 16px;
    height: 16px;
    display: block;
    text-indent: -99999px;
    overflow: hidden;
    background: url(../../../../assets/ui-icons_3d80b3_256x240.png) no-repeat -112px -80px;
    padding: 0;
    border: 0;
    font-size: 100%;
    font-style: normal;
    vertical-align: baseline;
    outline: 0;
    font-weight: bold;
    line-height: normal;
    cursor: pointer;
    text-align: center;
  }

  span:hover {
    background: url(../../../../assets/ui-icons_2694e8_256x240.png) no-repeat -112px -80px;
  }
</style>

